import { render, staticRenderFns } from "./reisetermin-anlegen-modal.vue?vue&type=template&id=4b68b6ff&scoped=true"
import script from "./reisetermin-anlegen-modal.vue?vue&type=script&lang=js"
export * from "./reisetermin-anlegen-modal.vue?vue&type=script&lang=js"
import style0 from "./reisetermin-anlegen-modal.vue?vue&type=style&index=0&id=4b68b6ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b68b6ff",
  null
  
)

export default component.exports